/**
 * Created by bob.gear on 12/02/2015.
 */
var EICDataStream3MemberNotes = angular.module("EICDataStream3.memberNotes", [
    "EICDataStream3.config",
    "ui.router",
    "ngResource",
    "ngSanitize",
    "EICDataStream3.resources",
    "jqShowEffect",
    "truncate",
    "ui.directives",
    'ui.bootstrap'
  ])
  .config(function() {
  });


EICDataStream3MemberNotes.directive('modaldraggable', ['$document',
  function ($document) {
  "use strict";
  return function (scope, element) {
    var body = angular.element(document.getElementsByTagName("body"));
    var startLeft = ( body[0].clientWidth - 600 )/2;
    var startTop = 25;
    var startX = 0, //(element[0].parentElement.offsetWidth = element[0].offsetWidth)/2,
      startY = 0,
      x = startLeft,
      y = startTop;
    element = angular.element(document.getElementsByClassName("modal-dialog"));
    console.log("added directive");


    element.css({
      position: 'fixed',
      cursor: 'move',
      left: "" +( body[0].clientWidth - 600)/2 + "px",
      top: "" + startTop + "px"
    });


    element.on('mousedown', function (event) {
      // ignore all but a mousedown on a modal-header
      if(event.target.className.indexOf("modal-header") !== -1
      || event.target.className.indexOf("modal-title") !== -1) {

        // Prevent default dragging of selected content
        event.preventDefault();
        startX = event.screenX - x;
        startY = event.screenY - y;
        $document.on('mousemove', mousemove);
        $document.on('mouseup', mouseup);
      }
    });

    function mousemove(event) {
      y = event.screenY - startY;
      x = event.screenX - startX;
      element.css({
        top: y + 'px',
        left: x + 'px'
      });
    }

    function mouseup() {
      $document.unbind('mousemove', mousemove);
      $document.unbind('mouseup', mouseup);
    }
  };
}]);

EICDataStream3MemberNotes.controller('createMemberNoteDialogCtrl', ['$scope','$uibModalInstance', 'data', 'memberNote' ,
  function ($scope, $uibModalInstance, data, memberNote){
    //-- Variables --//
    $scope.maxNoteLength = 999;
    $scope.memberNoteText = '';

    //-- Methods --//

    $scope.cancel = function(){
      $uibModalInstance.dismiss('Canceled');
    }; // end cancel

    $scope.save = function(){
      // Call the save method on the MemberNotes resource to save the note.

      var newMemberNote = new memberNote();
      newMemberNote.projectID = data.projectID;
      newMemberNote.noteText = $scope.memberNoteText;
      var promise = newMemberNote.$save(function(){
        // splice the new member note it not he top of the
        // list of existing notes. one way to do this would
        // be to  pass the projectDataService into the dialog
        // controller - but that sounds like tying things up
        // too much.
        // I think it is better to pass back a result object
        // ready for the caller to do the splicing
        $uibModalInstance.close(newMemberNote)
      });

      // $modalInstance.close()
    }; // end save

    $scope.hitEnter = function(evt){
      if(angular.equals(evt.keyCode,13) && !(angular.equals($scope.user.name,null) || angular.equals($scope.user.name,'')))
        $scope.save();
    };
  }]); // end controller(createMemberNoteDialogCtrl)



EICDataStream3MemberNotes.controller('updateMemberNoteDialogCtrl', ['$scope','$uibModalInstance', 'data', 'memberNote' ,
  function($scope,$uibModalInstance,data, memberNote){
    //-- Variables --//
    $scope.maxNoteLength = 999;
    $scope.memberNote = data.memberNote;
    //-- Methods --//

    $scope.cancel = function(){
      $uibModalInstance.dismiss('Canceled');
    }; // end cancel

    $scope.update = function(updatedMemberNote){
      // Call the update method on the MemberNotes resource to save
      // the note once it has been edited

      var promise = memberNote.update({noteID: $scope.memberNote.projectNoteID,
            memberNote: $scope.memberNote},
          function(){
            // splice the new member note it not he top of the
            // list of existing notes. one way to do this would
            // be to  pass the projectDataService into the dialog
            // controller - but that sounds like tying things up
            // too much.
            // I think it is better to pass back a result object
            // ready for the caller to do the splicing
            $uibModalInstance.close($scope.memberNote)
          });

    }; // end update

    $scope.hitEnter = function(evt){
      if(angular.equals(evt.keyCode,13) && !(angular.equals($scope.user.name,null) || angular.equals($scope.user.name,'')))
        $scope.save();
    };
  }]); // end controller(createMemberNoteDialogCtrl)



EICDataStream3MemberNotes.controller('deleteMemberNoteDialogCtrl', ['$scope','$uibModalInstance', 'data', 'memberNote' ,
  function($scope,$uibModalInstance,data, memberNote){
    //-- Variables --//
    $scope.memberNote = data.memberNote;
    $scope.memberNoteText = data.memberNote.note;


    //-- Methods --//

    $scope.cancel = function(){
      $uibModalInstance.dismiss('Canceled');
    }; // end cancel

    $scope.delete = function(){
      // Call the delete method on the MemberNotes resource to delete the note.

      var promise = memberNote.delete({noteID: data.memberNote.projectNoteID}, function(){
        // remove the current object from the list of project notes
        // this should happen in the caller if the delete reports success
        $uibModalInstance.close(data.memberNote);
      });

    }; // end delete

    $scope.hitEnter = function(evt){
      if(angular.equals(evt.keyCode,13) && !(angular.equals($scope.user.name,null) || angular.equals($scope.user.name,'')))
        $scope.delete();
    };
  }]);// end controller(deleteMemberNoteDialogCtrl)



